import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const BlankSlate = () => (
  <Box
    alignItems="center"
    justifyContent="center"
    borderRadius={{ all: 'abs008' }}
    paddingY="s32"
    paddingX="s24"
    border={{
      all: {
        width: 's1',
        color: 'grey400',
        style: 'solid',
      },
    }}
  >
    <Text size="200">
      {i18n.t('time_tracking.settings.time_blocks.worked_time_categories.blank_slate')}
    </Text>
  </Box>
)

export default BlankSlate
